// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.location-globe-container {
  /* width: 74%; */
  position: relative;
  flex: 1 1;
  height: 93%;
  transition: all 0.3s ease;
}

.location-globe-container.expanded {
  flex: 3 1;
}
.mapboxgl-canvas {
  width: 692.812px !important;
  height: 765.094px !important;
}


.location-map-container {
  /* width: 74%; */
  height: 99%;
  border-radius: 0px 0px 0px 10px;
  overflow: hidden;
}

.location-rotation-toggle {
  position: absolute;
  /* margin-right: 24.5%; */
  bottom: 50px;
  right: 20px;
  padding: 12px;
  border-radius: 50%;
  background: #65ccb7;
  color: white;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(101, 204, 183, 0.3);
  z-index: 1;
}

.location-rotation-toggle:hover {
  transform: scale(1.1);
  box-shadow: 0 2px 15px rgba(101, 204, 183, 0.5);
}

.location-marker {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(255, 0, 0);
  animation: location-pulse 2s infinite;
}

.location-marker.twitter {
  background-color: #1DA1F2;
}

.location-marker.instagram {
  background-color: #E1306C;
}

.location-marker svg {
  width: 18px;
  height: 18px;
}

@keyframes location-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}

.location-mapboxgl-popup {
  max-width: 200px;
}

.location-mapboxgl-popup-content {
  background: #2a2a2a;
  color: white;
  border: 1px solid #65ccb7;
  padding: 10px;
  border-radius: 8px;
}

.location-mapboxgl-popup-content h3 {
  margin: 0;
  color: #65ccb7;
}

.location-mapboxgl-popup-close-button {
  color: #65ccb7;
}

.location-radius-slider {
  position: absolute;
  top: 20px;
  left: 20px;
  background: rgba(42, 42, 42, 0.9);
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #65ccb7;
  color: white;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 200px;
}

.location-radius-slider label {
  font-size: 14px;
  color: #65ccb7;
}

.location-radius-slider input[type="range"] {
  width: 100%;
  cursor: pointer;
}

.location-radius-slider span {
  font-size: 12px;
  text-align: center;
}

@media (max-width: 768px) {
  .location-globe-container {
    height: 50vh;
  }
  
  .location-radius-slider {
    top: 10px;
    left: 10px;
    padding: 10px;
    min-width: 150px;
  }
}`, "",{"version":3,"sources":["webpack://./src/globe/components/GlobeMap/GlobeMap.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;EACP,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;AACA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;;AAGA;EACE,gBAAgB;EAChB,WAAW;EACX,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,+CAA+C;EAC/C,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,4CAA4C;EAC9C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,iCAAiC;EACjC,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,SAAS;IACT,UAAU;IACV,aAAa;IACb,gBAAgB;EAClB;AACF","sourcesContent":[".location-globe-container {\n  /* width: 74%; */\n  position: relative;\n  flex: 1;\n  height: 93%;\n  transition: all 0.3s ease;\n}\n\n.location-globe-container.expanded {\n  flex: 3;\n}\n.mapboxgl-canvas {\n  width: 692.812px !important;\n  height: 765.094px !important;\n}\n\n\n.location-map-container {\n  /* width: 74%; */\n  height: 99%;\n  border-radius: 0px 0px 0px 10px;\n  overflow: hidden;\n}\n\n.location-rotation-toggle {\n  position: absolute;\n  /* margin-right: 24.5%; */\n  bottom: 50px;\n  right: 20px;\n  padding: 12px;\n  border-radius: 50%;\n  background: #65ccb7;\n  color: white;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 10px rgba(101, 204, 183, 0.3);\n  z-index: 1;\n}\n\n.location-rotation-toggle:hover {\n  transform: scale(1.1);\n  box-shadow: 0 2px 15px rgba(101, 204, 183, 0.5);\n}\n\n.location-marker {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 2px solid white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgb(255, 0, 0);\n  animation: location-pulse 2s infinite;\n}\n\n.location-marker.twitter {\n  background-color: #1DA1F2;\n}\n\n.location-marker.instagram {\n  background-color: #E1306C;\n}\n\n.location-marker svg {\n  width: 18px;\n  height: 18px;\n}\n\n@keyframes location-pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);\n  }\n  70% {\n    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);\n  }\n}\n\n.location-mapboxgl-popup {\n  max-width: 200px;\n}\n\n.location-mapboxgl-popup-content {\n  background: #2a2a2a;\n  color: white;\n  border: 1px solid #65ccb7;\n  padding: 10px;\n  border-radius: 8px;\n}\n\n.location-mapboxgl-popup-content h3 {\n  margin: 0;\n  color: #65ccb7;\n}\n\n.location-mapboxgl-popup-close-button {\n  color: #65ccb7;\n}\n\n.location-radius-slider {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  background: rgba(42, 42, 42, 0.9);\n  padding: 15px;\n  border-radius: 8px;\n  border: 1px solid #65ccb7;\n  color: white;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: 200px;\n}\n\n.location-radius-slider label {\n  font-size: 14px;\n  color: #65ccb7;\n}\n\n.location-radius-slider input[type=\"range\"] {\n  width: 100%;\n  cursor: pointer;\n}\n\n.location-radius-slider span {\n  font-size: 12px;\n  text-align: center;\n}\n\n@media (max-width: 768px) {\n  .location-globe-container {\n    height: 50vh;\n  }\n  \n  .location-radius-slider {\n    top: 10px;\n    left: 10px;\n    padding: 10px;\n    min-width: 150px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
